import { LoginService } from 'src/app/services/login.service';
import { Injectable } from '@angular/core';

// import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthKeycloakService } from '../../services/auth-keycloak.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  constructor(
    private authKeycloakService: AuthKeycloakService,
    private router: Router) { }

async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    // 3. A lógica interna é atualizada para usar o Keycloak
    const authenticated = await this.authKeycloakService.isLoggedIn();

    if (authenticated) {
      // Se estiver autenticado, permite o acesso
      return true;
    } else {
      // Se não, inicia o fluxo de login do Keycloak
      await this.authKeycloakService.login(window.location.origin + state.url);
      // E impede a navegação atual
      return false;
    }

  }
}